import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// أنماط الزر
const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.size === 'large' ? '0.875rem 2rem' : 
    props.size === 'small' ? '0.5rem 1rem' : '0.75rem 1.5rem'};
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: ${props => props.size === 'large' ? '1.125rem' : 
    props.size === 'small' ? '0.875rem' : '1rem'};
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  outline: none;
  
  /* لون الخلفية حسب النوع */
  background-color: ${props => {
    switch(props.variant) {
      case 'secondary':
        return 'var(--secondary-color)';
      case 'outline':
        return 'transparent';
      case 'success':
        return 'var(--success)';
      case 'warning':
        return 'var(--warning)';
      case 'error':
        return 'var(--error)';
      default:
        return 'var(--primary-color)';
    }
  }};
  
  /* لون النص حسب النوع */
  color: ${props => props.variant === 'outline' ? 'var(--primary-color)' : 'var(--white)'};
  
  /* حدود الزر (فقط للأزرار المحددة بالخطوط) */
  border: ${props => props.variant === 'outline' ? '2px solid var(--primary-color)' : 'none'};
  
  /* ظلال للأزرار غير المسطحة */
  box-shadow: ${props => props.$flat ? 'none' : '0 4px 6px rgba(0, 0, 0, 0.1)'};
  
  /* تعطيل الزر */
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  
  /* أيقونة قبل النص */
  svg {
    margin-left: ${props => props.$iconPosition === 'right' ? '0' : '0.5rem'};
    margin-right: ${props => props.$iconPosition === 'right' ? '0.5rem' : '0'};
    font-size: ${props => props.size === 'large' ? '1.25rem' : 
      props.size === 'small' ? '0.875rem' : '1rem'};
  }
  
  /* تحميل */
  .loading-spinner {
    margin-left: 0.5rem;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* تأثيرات التحويم */
  &:hover:not(:disabled) {
    background-color: ${props => {
      switch(props.variant) {
        case 'secondary':
          return '#E56A3C';
        case 'outline':
          return 'var(--primary-color)';
        case 'success':
          return '#0DA271';
        case 'warning':
          return '#E08C00';
        case 'error':
          return '#DC3030';
        default:
          return 'var(--primary-dark)';
      }
    }};
    
    /* تغيير لون النص عند التحويم للأزرار ذات الخطوط */
    color: ${props => props.variant === 'outline' ? 'var(--white)' : 'var(--white)'};
    
    /* تأثير رفع طفيف */
    transform: ${props => props.disabled ? 'none' : 'translateY(-2px)'};
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  /* عرض كامل */
  width: ${props => props.$fullWidth ? '100%' : 'auto'};
`;

// مكون الزر
const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  to = null, 
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = 'left',
  flat = false,
  fullWidth = false,
  type = 'button',
  onClick,
  ...props 
}) => {
  // إذا كان الزر رابطًا، استخدم مكون Link
  if (to) {
    return (
      <StyledButton 
        as={Link} 
        to={to}
        variant={variant}
        size={size}
        disabled={disabled}
        $iconPosition={iconPosition}
        $flat={flat}
        $fullWidth={fullWidth}
        {...props}
      >
        {iconPosition === 'left' && icon}
        {children}
        {iconPosition === 'right' && icon}
      </StyledButton>
    );
  }
  
  // إذا كان زرًا عاديًا
  return (
    <StyledButton 
      type={type}
      variant={variant}
      size={size}
      disabled={disabled || loading}
      onClick={onClick}
      $iconPosition={iconPosition}
      $flat={flat}
      $fullWidth={fullWidth}
      {...props}
    >
      {iconPosition === 'left' && icon}
      {children}
      {iconPosition === 'right' && icon}
      {loading && <span className="loading-spinner">●</span>}
    </StyledButton>
  );
};

export default Button;